/**
 * jescard brand simple index
 */
export default {
  searchForm: {
    shopLabel: '主商城',
    shopPlaceholder: '请选择商城',
    screenButtonText: '筛选',
    priceTypeLabel: '价格类型',
    currLabel: '货币',
    TimeLabel: '时间',
    resetButtonText: '重置',
    searchButtonText: '搜索',
    selectedBrand: '已选品牌',
    selectedShop: '已选商城',
    selectedGroup: '已选收藏夹',
    ruleCurrMsg: '选择货币',
    ruleDateMsg: '请选择日期',
    report: '每日报告记录',
    saveReport: '保存为每日报告条件',
    saveReport_text: '当前已有每日报告，是否保存?',
    saveReport_text1: '当前没有每日报告，是否保存?',
    saveSuccess: '保存成功',
    saveError: '保存失败,请稍后再试',
    on: '开启',
    off: '关闭',
    onMsg: `The report data includes Top 10 products that with the most price advantage and with the least advantage. 
          All data is extracted based on the conditions you selected on the Brand-Index page on AI Tracking system according 
          to the selected price type throught the formula of dividing the benchmark shop price by comparison mall price. 
          It will send to you via email everyday, if you do not wish to receive the report in the future, please free feel 
          to turn off the subscription button on the Brand-Index page.`,
    onSuccessMsg: '开启成功',
    onFailMsg: '请保存每日报告的选定条件',
    offSuccessMsg: '关闭成功',
    offFailMsg: '关闭失败',
    screenModal: {
      title: '筛选',
      subText: '确认',
      closeText: '取消',
      brandLabel: '已选条件：',
      shopLabel: '已选条件：',
      selectShopMsg: '请选择商城!',
      noBrandSelectMsg: '请选择品牌！',
      noShopSelectMsg: '请选择对比商城！',
      shop: '商城',
      selected: '已选',
    },
    reportModal: {
      title: '每日报告记录',
      name: '名称',
      time: '时间',
      status: '状态',
      status_all: '全部',
      status_on: '已发送',
      status_off: '待发送',
      selectDownload: '批量下载',
      reportName: '报告名称',
      sendTime: '发送时间',
      view: '条件回显',
      download: '下载',
    },
  },
  jescAnalysisCard: {
    title: '品牌指数',
    exportButtonText: '导出',
    noData: '没有数据',
    chartTitle: '指数越高，主商城的价格越低。点击条形图分析具体商城。',
  },
  brandAnalysisModal: {
    title: '品牌分析',
    exportBtn: '导出',
    okBtn: '关闭',
    shop: '商城：',
    priceType: '价格类型：',
    tableColumns: {
      category: '分类',
      index: '指数',
      operate: '操作',
      view: '查看',
    },
  },
  productDetailModel: {
    title: '商品详情',
    comparisonShop: '对比商城：',
    brand: '品牌：',
    priceType: '价格类型：',
    curr: '货币：',
    lowerTitle: '商品价格低于主商城',
    higherTitle: '商品价格高于主商城',
    loadMore: '加载更多',
    noMore: '暂无数据',
    export: '导出',
    lower: '劣势商品',
    high: '优势商品',
    keyword: '关键字',
    all: '全部',
    tableColumns: {
      brand: '品牌',
      name: '名称',
      image: '图片',
      upc: 'UPC',
      comPrice: '对比商城价格',
      myPrice: '主商城价格',
      difference: '价格差',
      differencePercent: '百分比差异',
      index: '指数',
    },
  },
};
